import { Injectable } from '@angular/core';
import { fetchAuthSession } from 'aws-amplify/auth';
import { PayoutFeeConfig } from 'src/app/types/PayoutFeeConfig';
import { environment } from '../../../environments/environment';
import {
  AffiliateCommissionsData,
  AffiliateCustomersData,
  AffiliateUserData,
  BeneficialOwner,
  client,
  CompliancePackageRequestSummary,
  ContactFormResponseModel,
  createCustomer,
  CreateCustomerRequestContent,
  createInvoice,
  createInvoicePreview,
  CreateInvoicePreviewRequestContent,
  CreateInvoiceRequestContent,
  createOrUpdateNfcCard,
  CreateOrUpdateNfcCardRequestContent,
  createPartner,
  CreatePartnerRequestContent,
  CustomerModel,
  deleteBeneficialOwner,
  DeleteBeneficialOwnerResponseContent,
  deleteFileById,
  DeleteFileByIdData,
  DeleteFileByIdResponseContent,
  DepositModel,
  downloadCompliancePackage,
  FeeResponseModel,
  FileResponseModel,
  generateBankDetailsPdf,
  GenerateBankDetailsPdfData,
  generateHdfcIrmReport,
  GenerateHdfcIrmReportData,
  generateHdfcRequestLetter,
  GenerateHdfcRequestLetterData,
  getAffiliateCommissions,
  getAffiliateCustomers,
  getAnalyticsForPayoutsGraph,
  GetAnalyticsForPayoutsGraphData,
  GetAnalyticsForPayoutsGraphResponseModel,
  getBankAccountByPayoutId,
  getBankAccounts,
  GetBankAccountsResponseContent,
  getBeneficialOwners,
  getCompliancePackageRequests,
  getCostsFromFirc,
  GetCostsFromFircResponseModel,
  getCustomerById,
  type GetCustomerByIdData,
  getCustomers,
  GetCustomersData,
  getCustomerSettings,
  GetCustomerSettingsResponseModel,
  getDeposits,
  getEmailUnsubscribeStatus,
  getFees,
  GetFeesData,
  getFileById,
  getFileContentById,
  getFilesByCustomerId,
  GetFilesByCustomerIdResponseModel,
  getFircUploadResponseById,
  GetFircUploadResponseByIdModel,
  getGenericFees,
  GetGenericFeesData,
  getIdentityVerifications,
  GetIdentityVerificationsResponseModel,
  getInvoiceById,
  getInvoiceByPayoutId,
  getInvoices,
  GetInvoicesData,
  getNfcCardDetails,
  getOrCreateUser,
  getPartnerById,
  GetPartnerByIdData,
  getPartners,
  GetPartnersData,
  getPayouts,
  GetPayoutsData,
  getPurposeCodes,
  getUserByEmail,
  IndianBankAccount,
  InvoicesModel,
  NfcCardModel,
  PartnerModel,
  patchBankAccount,
  PatchBankAccountRequestContent,
  PatchBankAccountResponseContent,
  patchBeneficialOwner,
  PatchBeneficialOwnerRequestContent,
  PatchBeneficialOwnerResponseContent,
  patchCustomer,
  PatchCustomerRequestContent,
  patchCustomerSettings,
  PatchCustomerSettingsData,
  PatchCustomerSettingsResponseModel,
  patchDeposit,
  PatchDepositRequestContent,
  PatchDepositResponseModel,
  patchIdentityVerificationQueryDocuments,
  PatchIdentityVerificationQueryDocumentsRequestContent,
  PatchIdentityVerificationQueryDocumentsResponseModel,
  patchUser,
  PatchUserData,
  patchVerificationFlowSubmission,
  PatchVerificationFlowSubmissionResponseDataModel,
  patchVerificationStepData,
  PatchVerificationStepDataRequestContent,
  PatchVerificationStepDataResponseModel,
  PayoutModel,
  PayoutRequestResponse,
  postAffiliateUser,
  PostAffiliateUserRequestContent,
  postBeneficialOwner,
  PostBeneficialOwnerRequestContent,
  PostBeneficialOwnerResponseContent,
  postCompliancePackageRequest,
  PostCompliancePackageRequestRequestContent,
  postContactForm,
  PostContactFormData,
  postCurrencyWallet,
  PostCurrencyWalletRequestContent,
  PostCurrencyWalletResponseContent,
  postEmailUnsubscribe,
  PostEmailUnsubscribeRequestContent,
  postIdentityVerification,
  PostIdentityVerificationRequestContent,
  PostIdentityVerificationResponseDataModel,
  postInvoiceOverdueReminder,
  PostInvoiceOverdueReminderRequestContent,
  PostInvoiceOverdueReminderResponseContent,
  postMultiCurrencyEnable,
  PostMultiCurrencyEnableRequestContent,
  PostMultiCurrencyEnableResponseContent,
  postPayouts,
  postPayoutsPreview,
  PostPayoutsPreviewRequestContent,
  PostPayoutsPreviewResponseContent,
  PostPayoutsRequestContent,
  Purpose,
  PurposeCodeModel,
  RequestStatus,
  sendOtp,
  SendOtpData,
  UnsubscribeStatusModel,
  updateAffiliateCustomerFee,
  UpdateAffiliateCustomerFeeRequestContent,
  updateInvoiceById,
  UpdateInvoiceByIdRequestContent,
  updatePartner,
  UpdatePartnerData,
  UpdatePartnerRequestContent,
  uploadFile,
  UploadFileData,
  UploadFileInputPayload,
  UploadFileResponseModel,
  UserModel,
  VerificationStepName,
  verifyOtp,
  VerifyOtpData,
  VerifyOtpResponseModel,
} from '../../api/autogenerated';
import { OpenApiException } from '../../types/responses/OpenApiException';
import { IpService } from '../ip.service';

@Injectable({
  providedIn: 'root',
})
export class OpenApiService {
  private client = client;

  private options: {
    headers: {
      'X-Organization-ID': string;
      customer_id: string;
      'X-User-Ip': string;
      'X-User-Agent': string;
      // 'Content-Type': string
      // 'Authorization': string
    };
  };

  constructor() {
    this.options = {
      headers: {
        'X-Organization-ID': environment.organization_id,
        customer_id: '',
        'X-User-Ip': '',
        'X-User-Agent': '',
        // 'Content-Type': ''
      },
    };

    this.client.setConfig({
      baseURL: environment.api_endpoint,
    });

    this.client.instance.interceptors.request.use(
      async (config) => {
        config.headers['X-Organization-ID'] = environment.organization_id;
        config.headers = await IpService.addHeaders(config.headers);
        this.options.headers['X-User-Agent'] = config.headers['X-User-Agent'];
        this.options.headers['X-User-Ip'] = config.headers['X-User-Ip'];
        try {
          var cognitoTokens = (await fetchAuthSession()).tokens;
          let rawToken = cognitoTokens?.accessToken?.toString();
          config.headers['Authorization'] = `Bearer ${rawToken}`;
        } catch (error) {
          console.error('Error fetching Amplify Auth token:', error);
          // throw error;
        }
        return config;
      },
      (error: any) => {
        // Handle request configuration errors
        return Promise.reject(error);
      },
    );
  }

  private provideUserFriendlyMessages(
    response: any,
    defaultMessage: string,
  ): OpenApiException {
    let returnValue: OpenApiException = {
      apiErrorMessage: '',
      userMessage: '',
    };
    if (response && response.code == 'ERR_NETWORK') {
      returnValue.userMessage =
        'Network error: Unable to connect to the server. Please check your internet connection and try again.';
      returnValue.apiErrorMessage = 'response message: ' + response?.message;
      return returnValue;
    }
    if (response && response.code == 'ERR_BAD_RESPONSE') {
      if (
        response.response &&
        response.response.data &&
        response.response.data.error &&
        response.response.data.error.code &&
        response.response.data.error.code == 'INTERNAL_SERVER_ERROR'
      ) {
        returnValue.userMessage = response.response.data.message;
        returnValue.apiErrorMessage =
          'response message: ' +
          response?.message +
          '; response data message: ' +
          response.response.data.message +
          '; response data error details: ' +
          response.response.data.error.details +
          '; response data error code: ' +
          response.response.data.error.code;
        return returnValue;
      }
    }
    if (response && response.code == 'ERR_BAD_REQUEST') {
      if (
        response.response &&
        response.response.data &&
        response.response.data.error &&
        response.response.data.error.code &&
        (response.response.data.error.code == 'CLIENT_ERROR' ||
          response.response.data.error.code == 'FORBIDDEN' ||
          response.response.data.error.code == 'NOT_FOUND')
      ) {
        returnValue.userMessage = response.response.data.error.details;
        returnValue.apiErrorMessage =
          'response message: ' +
          response?.message +
          '; response data message: ' +
          response.response.data.message +
          '; response data error details: ' +
          response.response.data.error.details +
          '; response data error code: ' +
          response.response.data.error.code;
        return returnValue;
      }
    }

    return returnValue;
  }

  private async handleRequest<T extends object | null>(
    request: Promise<T>,
    errorMessage: string,
  ): Promise<{
    success: boolean;
    data?: T extends { data: infer D } ? D : T;
    error?: string;
  }> {
    try {
      const response = await request;
      if (response && typeof response === 'object' && 'data' in response) {
        // @ts-ignore
        return { success: true, data: response.data };
      }
      throw this.provideUserFriendlyMessages(response, errorMessage);
      // return { success: false, error: (response as any)?.error.error.details ?? errorMessage };
    } catch (error) {
      console.log('error');
      throw error;
      // return { success: false, error: `${errorMessage}: ${(error as Error).message}` };
    }
  }

  async getCustomers(
    queryFilters: GetCustomersData['query'],
  ): Promise<{ success: boolean; data: Array<CustomerModel>; error: string }> {
    let response = await this.handleRequest(
      getCustomers({
        ...this.options,
        query: queryFilters,
      }),
      'Error fetching customers',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return { success: false, error: 'Api response error', data: [] };
      }
      return {
        success: true,
        data: dataFromResponse.data as Array<CustomerModel>,
        error: '',
      };
    } else {
      return { success: false, error: response.error ?? '', data: [] };
    }
  }

  async getCustomerById(
    customerIdFilter: GetCustomerByIdData['path'],
  ): Promise<{ success: boolean; data: CustomerModel; error: string }> {
    let response = await this.handleRequest(
      getCustomerById({
        ...this.options,
        path: customerIdFilter,
      }),
      'Error fetching customer',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return { success: false, error: 'Api response error', data: {} };
      }
      return {
        success: true,
        data: dataFromResponse.data as CustomerModel,
        error: '',
      };
    } else {
      return { success: false, error: response.error ?? '', data: {} };
    }
  }

  async patchCustomer(
    body: PatchCustomerRequestContent,
  ): Promise<{ success: boolean; data: CustomerModel; error: string }> {
    let response = await this.handleRequest(
      patchCustomer({
        ...this.options,
        body: body,
      }),
      'Error updating customer',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return { success: false, error: 'Api response error', data: {} };
      }
      return {
        success: true,
        data: dataFromResponse.data as CustomerModel,
        error: '',
      };
    } else {
      return { success: false, error: response.error ?? '', data: {} };
    }
  }

  async getPartners(
    queryFilters: GetPartnersData['query'],
  ): Promise<{ success: boolean; data: Array<PartnerModel>; error: string }> {
    let response = await this.handleRequest(
      getPartners({
        ...this.options,
        query: queryFilters,
      }),
      'Error fetching partners',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return { success: false, error: 'Api response error', data: [] };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: [] };
    }
  }

  async getInvoices(
    owningCustomerId: string,
    queryFilters: GetInvoicesData['query'],
  ): Promise<{ success: boolean; data: Array<InvoicesModel>; error: string }> {
    this.options.headers.customer_id = owningCustomerId;
    let response = await this.handleRequest(
      getInvoices({
        ...this.options,
        query: queryFilters,
      }),
      'Error fetching invoices',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return { success: false, error: 'Api response error', data: [] };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: [] };
    }
  }

  async getInvoiceById(
    invoiceId: string,
  ): Promise<{ success: boolean; data: InvoicesModel; error: string }> {
    // @todo customer id check needs to be implemented
    let response = await this.handleRequest(
      getInvoiceById({
        ...this.options,
        path: { invoice_id: invoiceId },
      }),
      'Error fetching invoices',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as InvoicesModel,
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as InvoicesModel,
      };
    }
  }

  async createInvoice(
    owningCustomerId: string,
    body: CreateInvoiceRequestContent,
  ): Promise<{ success: boolean; data: InvoicesModel; error: string }> {
    this.options.headers.customer_id = owningCustomerId;
    let response = await this.handleRequest(
      createInvoice({
        ...this.options,
        body: body,
      }),
      'Error creating invoice',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as InvoicesModel,
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as InvoicesModel,
      };
    }
  }

  async createInvoicePreview(
    owningCustomerId: string,
    body: CreateInvoicePreviewRequestContent,
  ): Promise<{ success: boolean; data: Blob; error: string }> {
    this.options.headers.customer_id = owningCustomerId;
    let response = await this.handleRequest(
      createInvoicePreview({
        ...this.options,
        body: body,
      }),
      'Error creating invoice preview',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (dataFromResponse === undefined) {
        return {
          success: false,
          error: 'Api response error',
          data: new Blob(),
        };
      }
      return { success: true, data: dataFromResponse, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: new Blob(),
      };
    }
  }

  async updateInvoiceById(
    invoiceId: string,
    body: UpdateInvoiceByIdRequestContent,
  ): Promise<{ success: boolean; data: InvoicesModel; error: string }> {
    let response = await this.handleRequest(
      updateInvoiceById({
        ...this.options,
        body: body,
        path: { invoice_id: invoiceId },
      }),
      'Error updating invoice',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: response.error ?? 'Api response error',
          data: {} as InvoicesModel,
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as InvoicesModel,
      };
    }
  }

  async createCustomer(
    body: CreateCustomerRequestContent,
  ): Promise<{ success: boolean; data: CustomerModel; error: string }> {
    let response = await this.handleRequest(
      createCustomer({
        ...this.options,
        body: body,
      }),
      'Error creating customer',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as CustomerModel,
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as CustomerModel,
      };
    }
  }

  async patchVerificationFlowSubmission(verificationId: string): Promise<{
    success: boolean;
    data: PatchVerificationFlowSubmissionResponseDataModel;
    error: string;
  }> {
    let response = await this.handleRequest(
      patchVerificationFlowSubmission({
        ...this.options,
        path: { verification_id: verificationId },
      }),
      'Error updating verification steps flow',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as PatchVerificationFlowSubmissionResponseDataModel,
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as PatchVerificationFlowSubmissionResponseDataModel,
      };
    }
  }

  async patchVerificationStepData(
    verificationId: string,
    stepId: VerificationStepName,
    body: PatchVerificationStepDataRequestContent,
  ): Promise<{
    success: boolean;
    data: PatchVerificationStepDataResponseModel;
    error: string;
  }> {
    let response = await this.handleRequest(
      patchVerificationStepData({
        ...this.options,
        path: { step_id: stepId, verification_id: verificationId },
        body: body,
      }),
      'Error updating verification flow',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as PatchVerificationFlowSubmissionResponseDataModel,
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as PatchVerificationFlowSubmissionResponseDataModel,
      };
    }
  }

  async postIdentityVerification(
    body: PostIdentityVerificationRequestContent,
  ): Promise<{
    success: boolean;
    data: PostIdentityVerificationResponseDataModel;
    error: string;
  }> {
    let response = await this.handleRequest(
      postIdentityVerification({
        ...this.options,
        body: body,
      }),
      'Error creating verification flow',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as PostIdentityVerificationResponseDataModel,
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as PostIdentityVerificationResponseDataModel,
      };
    }
  }

  async getOrCreateUser(): Promise<{
    success: boolean;
    data: UserModel;
    error: string;
  }> {
    this.options.headers['X-Organization-ID'] = environment.organization_id;
    this.options.headers['customer_id'] = '';
    let response = await this.handleRequest(
      getOrCreateUser({
        ...this.options,
        body: {},
      }),
      'Error creating new user',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as UserModel,
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as UserModel,
      };
    }
  }

  async createPartner(
    owningCustomerId: string,
    body: CreatePartnerRequestContent,
  ): Promise<{ success: boolean; data: PartnerModel; error: string }> {
    let response = await this.handleRequest(
      createPartner({
        headers: {
          ...this.options.headers,
          customer_id: owningCustomerId,
        },
        body: body,
      }),
      'Error creating new partner',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as PartnerModel,
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as PartnerModel,
      };
    }
  }

  async updatePartner(
    partnerIdFilter: UpdatePartnerData['path'],
    owningCustomerId: string,
    body: UpdatePartnerRequestContent,
  ): Promise<{ success: boolean; data: PartnerModel; error: string }> {
    console.log(body);
    this.options.headers.customer_id = owningCustomerId;
    let response = await this.handleRequest(
      updatePartner({
        ...this.options,
        path: partnerIdFilter,
        body: body,
      }),
      'Error creating new partner',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as PartnerModel,
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as PartnerModel,
      };
    }
  }

  async getPartnerById(
    partnerIdFilter: GetPartnerByIdData['path'],
  ): Promise<{ success: boolean; data: PartnerModel; error: string }> {
    let response = await this.handleRequest(
      getPartnerById({
        ...this.options,
        path: partnerIdFilter,
      }),
      'Error fetching customer',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as PartnerModel,
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as PartnerModel,
      };
    }
  }

  async getFees(
    owningCustomerId: string,
    queryFilters: GetFeesData['query'],
  ): Promise<{ success: boolean; data: FeeResponseModel; error: string }> {
    this.options.headers.customer_id = owningCustomerId;
    let response = await this.handleRequest(
      getFees({
        ...this.options,
        query: queryFilters,
      }),
      'Error fetching payout fees',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return { success: false, error: 'Api response error', data: {} };
      }
      return {
        success: true,
        data: dataFromResponse.data as FeeResponseModel,
        error: '',
      };
    } else {
      return { success: false, error: response.error ?? '', data: {} };
    }
  }

  async postPayouts(
    owningCustomerId: string,
    body: PostPayoutsRequestContent,
  ): Promise<{
    success: boolean;
    data: PayoutRequestResponse[];
    error: string;
  }> {
    this.options.headers.customer_id = owningCustomerId;
    let response = await this.handleRequest(
      postPayouts({
        ...this.options,
        body: body,
      }),
      'Error creating payout',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: [] as PayoutRequestResponse[],
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: [] as PayoutRequestResponse[],
      };
    }
  }

  async postPayoutsPreview(
    owningCustomerId: string,
    body: PostPayoutsPreviewRequestContent,
  ): Promise<{
    success: boolean;
    data: PostPayoutsPreviewResponseContent | null;
    error: string;
  }> {
    this.options.headers.customer_id = owningCustomerId;
    let response = await this.handleRequest(
      postPayoutsPreview({
        ...this.options,
        body: body,
      }),
      'Error fetching payout preview',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (dataFromResponse === undefined) {
        return { success: false, error: 'Api response error', data: null };
      }
      if (dataFromResponse.error) {
        return {
          success: false,
          error:
            dataFromResponse.error.details ??
            dataFromResponse.error.code ??
            'Payout preview error',
          data: dataFromResponse,
        };
      }
      return { success: true, data: dataFromResponse, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: null };
    }
  }

  async postInvoiceOverdueReminder(
    body: PostInvoiceOverdueReminderRequestContent,
  ): Promise<{
    success: boolean;
    data: PostInvoiceOverdueReminderResponseContent | null;
    error: string;
  }> {
    let response = await this.handleRequest(
      postInvoiceOverdueReminder({
        ...this.options,
        body,
      }),
      'Error sending overdue invoice reminders',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (dataFromResponse === undefined) {
        return { success: false, error: 'Api response error', data: null };
      }
      if (dataFromResponse.error) {
        return {
          success: false,
          error:
            dataFromResponse.error.details ??
            dataFromResponse.error.code ??
            'Overdue reminder error',
          data: dataFromResponse,
        };
      }
      return { success: true, data: dataFromResponse, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: null };
    }
  }

  async postCompliancePackageRequest(
    owningCustomerId: string,
    body: PostCompliancePackageRequestRequestContent,
  ): Promise<{
    success: boolean;
    data: {
      message: string;
      request_id?: string;
      request_status?: RequestStatus;
    };
    error: string;
  }> {
    this.options.headers.customer_id = owningCustomerId;
    const response = await this.handleRequest(
      postCompliancePackageRequest({
        ...this.options,
        body,
      }),
      'Error creating compliance package request',
    );
    if (response.success) {
      const dataFromResponse = response.data;
      if (dataFromResponse === undefined) {
        return {
          success: false,
          error: 'Api response error',
          data: { message: '' },
        };
      }
      return {
        success: true,
        data: dataFromResponse as {
          message: string;
          request_id?: string;
          request_status?: RequestStatus;
        },
        error: '',
      };
    }
    return {
      success: false,
      error: response.error ?? '',
      data: { message: '' },
    };
  }

  async getCompliancePackageRequests(
    owningCustomerId: string,
    requestId?: string,
  ): Promise<{
    success: boolean;
    data: {
      message: string;
      requests: Array<CompliancePackageRequestSummary>;
    };
    error: string;
  }> {
    this.options.headers.customer_id = owningCustomerId;
    const response = await this.handleRequest(
      getCompliancePackageRequests({
        ...this.options,
        query: requestId ? { request_id: requestId } : undefined,
      }),
      'Error fetching compliance package status',
    );
    if (response.success) {
      const dataFromResponse = response.data;
      if (dataFromResponse === undefined) {
        return {
          success: false,
          error: 'Api response error',
          data: {
            message: '',
            requests: [],
          },
        };
      }
      return {
        success: true,
        data: dataFromResponse as {
          message: string;
          requests: Array<CompliancePackageRequestSummary>;
        },
        error: '',
      };
    }
    return {
      success: false,
      error: response.error ?? '',
      data: {
        message: '',
        requests: [],
      },
    };
  }

  async downloadCompliancePackage(
    owningCustomerId: string,
    requestId: string,
  ): Promise<{
    success: boolean;
    data: { downloadUrl: string };
    error: string;
  }> {
    this.options.headers.customer_id = owningCustomerId;
    try {
      const axiosResponse = await downloadCompliancePackage({
        ...this.options,
        headers: {
          ...this.options.headers,
          Accept: 'application/json',
        },
        path: { request_id: requestId },
      });

      // axiosResponse.data is the raw response body from backend.
      const raw: any = axiosResponse.data;
      console.log('[downloadCompliancePackage] axiosResponse:', axiosResponse);
      console.log('[downloadCompliancePackage] raw data:', raw);
      const downloadUrl: string =
        raw?.url ||
        raw?.download_url ||
        raw?.downloadUrl ||
        raw?.presigned_url ||
        raw?.presignedUrl ||
        raw?.data?.url ||
        raw?.data?.download_url ||
        (typeof raw === 'string' && /^https?:\/\//i.test(raw) ? raw : '') ||
        '';

      if (!downloadUrl) {
        return {
          success: false,
          error:
            'Download URL not found. Please try again. If issue persists, contact support.',
          data: { downloadUrl: '' },
        };
      }
      return { success: true, data: { downloadUrl }, error: '' };
    } catch (error: any) {
      const parsed = this.provideUserFriendlyMessages(
        error,
        'Error downloading compliance package',
      );
      return {
        success: false,
        error: parsed.userMessage || 'Error downloading compliance package',
        data: { downloadUrl: '' },
      };
    }
  }

  async getAnalyticsForPayoutsGraph(
    owningCustomerId: string,
    queryFilters: GetAnalyticsForPayoutsGraphData['query'],
  ): Promise<{
    success: boolean;
    data: Array<GetAnalyticsForPayoutsGraphResponseModel>;
    error: string;
  }> {
    this.options.headers.customer_id = owningCustomerId;
    let response = await this.handleRequest(
      getAnalyticsForPayoutsGraph({
        ...this.options,
        query: queryFilters,
      }),
      'Error fetching payouts',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return { success: false, error: 'Api response error', data: [] };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: [] };
    }
  }

  async getPayouts(
    owningCustomerId: string,
    queryFilters: GetPayoutsData['query'],
  ): Promise<{ success: boolean; data: Array<PayoutModel>; error: string }> {
    this.options.headers.customer_id = owningCustomerId;
    let response = await this.handleRequest(
      getPayouts({
        ...this.options,
        query: queryFilters,
      }),
      'Error fetching payouts',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return { success: false, error: 'Api response error', data: [] };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: [] };
    }
  }

  async getBankAccounts(owningCustomerId: string): Promise<{
    success: boolean;
    data: GetBankAccountsResponseContent;
    error: string;
  }> {
    this.options.headers.customer_id = owningCustomerId;
    const empty = {} as GetBankAccountsResponseContent;
    const response = await this.handleRequest(
      getBankAccounts({
        ...this.options,
      }),
      'Error fetching bank accounts',
    );
    if (response.success) {
      const dataFromResponse = response.data;
      if (dataFromResponse === undefined) {
        return { success: false, error: 'Api response error', data: empty };
      }
      return { success: true, data: dataFromResponse, error: '' };
    }
    return { success: false, error: response.error ?? '', data: empty };
  }

  async patchBankAccount(
    owningCustomerId: string,
    bankAccountId: string,
    body: PatchBankAccountRequestContent,
  ): Promise<{
    success: boolean;
    data: PatchBankAccountResponseContent;
    error: string;
  }> {
    this.options.headers.customer_id = owningCustomerId;
    const empty = {} as PatchBankAccountResponseContent;
    const response = await this.handleRequest(
      patchBankAccount({
        ...this.options,
        path: { bank_account_id: bankAccountId },
        body,
      }),
      'Error updating bank account',
    );
    if (response.success) {
      const dataFromResponse = response.data;
      if (dataFromResponse === undefined) {
        return { success: false, error: 'Api response error', data: empty };
      }
      return { success: true, data: dataFromResponse, error: '' };
    }
    return { success: false, error: response.error ?? '', data: empty };
  }

  async getBankAccountByPayoutId(
    owningCustomerId: string,
    payoutId: string,
  ): Promise<{ success: boolean; data: IndianBankAccount; error: string }> {
    this.options.headers.customer_id = owningCustomerId;
    let response = await this.handleRequest(
      getBankAccountByPayoutId({
        ...this.options,
        path: { payout_id: payoutId },
      }),
      'Error fetching bank account by payout id',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as IndianBankAccount,
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as IndianBankAccount,
      };
    }
  }

  async getInvoiceByPayoutId(
    owningCustomerId: string,
    payoutId: string,
  ): Promise<{ success: boolean; data: InvoicesModel; error: string }> {
    this.options.headers.customer_id = owningCustomerId;
    let response = await this.handleRequest(
      getInvoiceByPayoutId({
        ...this.options,
        path: { payout_id: payoutId },
      }),
      'Error fetching invoice by payout id',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as InvoicesModel,
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as InvoicesModel,
      };
    }
  }

  async getDeposits(owningCustomerId: string): Promise<{
    success: boolean;
    data: Array<DepositModel>;
    error: string;
  }> {
    this.options.headers.customer_id = owningCustomerId;
    let response = await this.handleRequest(
      getDeposits({
        ...this.options,
      }),
      'Error fetching deposits',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return { success: false, error: 'Api response error', data: [] };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: [] };
    }
  }

  async patchDeposit(
    depositId: string,
    clientId: string,
  ): Promise<{
    success: boolean;
    data: PatchDepositResponseModel;
    error: string;
  }> {
    const requestBody: PatchDepositRequestContent = {
      partner_id: clientId,
    };

    let response = await this.handleRequest(
      patchDeposit({
        ...this.options,
        path: { deposit_id: depositId },
        body: requestBody,
      }),
      'Error updating deposit',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as PatchDepositResponseModel,
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as PatchDepositResponseModel,
      };
    }
  }

  async getBeneficialOwners(owningCustomerId: string): Promise<{
    success: boolean;
    data: Array<BeneficialOwner>;
    error: string;
  }> {
    this.options.headers.customer_id = owningCustomerId;
    let response = await this.handleRequest(
      getBeneficialOwners({
        ...this.options,
      }),
      'Error fetching beneficial owners',
    );
    if (response.success) {
      const dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return { success: false, error: 'Api response error', data: [] };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: [] };
    }
  }

  async postBeneficialOwner(
    owningCustomerId: string,
    body: PostBeneficialOwnerRequestContent,
  ): Promise<{
    success: boolean;
    data: PostBeneficialOwnerResponseContent;
    error: string;
  }> {
    this.options.headers.customer_id = owningCustomerId;
    const empty = {} as PostBeneficialOwnerResponseContent;
    const response = await this.handleRequest(
      postBeneficialOwner({
        ...this.options,
        body,
      }),
      'Error creating beneficial owner',
    );
    if (response.success) {
      const dataFromResponse = response.data;
      if (dataFromResponse === undefined) {
        return { success: false, error: 'Api response error', data: empty };
      }
      return { success: true, data: dataFromResponse, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: empty };
    }
  }

  async patchBeneficialOwner(
    owningCustomerId: string,
    ownerId: string,
    body: PatchBeneficialOwnerRequestContent,
  ): Promise<{
    success: boolean;
    data: PatchBeneficialOwnerResponseContent;
    error: string;
  }> {
    this.options.headers.customer_id = owningCustomerId;
    const empty = {} as PatchBeneficialOwnerResponseContent;
    const response = await this.handleRequest(
      patchBeneficialOwner({
        ...this.options,
        path: { owner_id: ownerId },
        body,
      }),
      'Error updating beneficial owner',
    );
    if (response.success) {
      const dataFromResponse = response.data;
      if (dataFromResponse === undefined) {
        return { success: false, error: 'Api response error', data: empty };
      }
      return { success: true, data: dataFromResponse, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: empty };
    }
  }

  async deleteBeneficialOwner(
    owningCustomerId: string,
    ownerId: string,
  ): Promise<{
    success: boolean;
    data: DeleteBeneficialOwnerResponseContent;
    error: string;
  }> {
    this.options.headers.customer_id = owningCustomerId;
    const empty = {} as DeleteBeneficialOwnerResponseContent;
    const response = await this.handleRequest(
      deleteBeneficialOwner({
        ...this.options,
        path: { owner_id: ownerId },
      }),
      'Error deleting beneficial owner',
    );
    if (response.success) {
      const dataFromResponse = response.data;
      if (dataFromResponse === undefined) {
        return { success: false, error: 'Api response error', data: empty };
      }
      return { success: true, data: dataFromResponse, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: empty };
    }
  }

  async postCurrencyWallet(
    owningCustomerId: string,
    body: PostCurrencyWalletRequestContent,
  ): Promise<{
    success: boolean;
    data: PostCurrencyWalletResponseContent;
    error: string;
  }> {
    this.options.headers.customer_id = owningCustomerId;
    const empty = {} as PostCurrencyWalletResponseContent;
    const response = await this.handleRequest(
      postCurrencyWallet({
        ...this.options,
        body,
      }),
      'Error creating currency wallet',
    );
    if (response.success) {
      const dataFromResponse = response.data;
      if (dataFromResponse === undefined) {
        return { success: false, error: 'Api response error', data: empty };
      }
      return { success: true, data: dataFromResponse, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: empty };
    }
  }

  async postMultiCurrencyEnable(
    owningCustomerId: string,
    body: PostMultiCurrencyEnableRequestContent,
  ): Promise<{
    success: boolean;
    data: PostMultiCurrencyEnableResponseContent;
    error: string;
  }> {
    this.options.headers.customer_id = owningCustomerId;
    const empty = {} as PostMultiCurrencyEnableResponseContent;
    const response = await this.handleRequest(
      postMultiCurrencyEnable({
        ...this.options,
        body,
      }),
      'Error enabling multi-currency',
    );
    if (response.success) {
      const dataFromResponse = response.data;
      if (dataFromResponse === undefined) {
        return { success: false, error: 'Api response error', data: empty };
      }
      return { success: true, data: dataFromResponse, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: empty };
    }
  }

  async getFileContentById(
    owningCustomerId: string,
    fileId: string,
    purpose: Purpose,
  ): Promise<{ success: boolean; data: Blob; error: string }> {
    this.options.headers.customer_id = owningCustomerId;
    this.options.headers['X-Organization-ID'] = environment.organization_id;
    let response = await this.handleRequest(
      getFileContentById({
        ...this.options,
        path: { file_id: fileId },
        query: { purpose: purpose },
      }),
      'Error fetching file',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (dataFromResponse === undefined || dataFromResponse === undefined) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as Blob,
        };
      }

      return { success: true, data: dataFromResponse, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: {} as Blob };
    }
  }

  async getFileDetailsById(
    owningCustomerId: string,
    fileId: string,
    purpose: Purpose,
  ): Promise<{ success: boolean; data: FileResponseModel; error: string }> {
    this.options.headers.customer_id = owningCustomerId;
    this.options.headers['X-Organization-ID'] = environment.organization_id;
    let response = await this.handleRequest(
      getFileById({
        ...this.options,
        path: { file_id: fileId },
        query: { purpose: purpose },
      }),
      'Error fetching file',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (dataFromResponse === undefined || dataFromResponse === null) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as FileResponseModel,
        };
      }

      return {
        success: true,
        data: dataFromResponse.data as FileResponseModel,
        error: '',
      };
    } else {
      return { success: false, error: response.error ?? '', data: {} };
    }
  }

  async getFilesByCustomerId(customerId: string): Promise<{
    success: boolean;
    data: GetFilesByCustomerIdResponseModel;
    error: string;
  }> {
    this.options.headers.customer_id = customerId;
    this.options.headers['X-Organization-ID'] = environment.organization_id;

    const response = await this.handleRequest(
      getFilesByCustomerId({
        ...this.options,
        headers: {
          ...this.options.headers,
          customer_id: customerId,
        },
      }),
      'Error fetching customer files',
    );

    if (response.success) {
      const dataFromResponse = response.data;
      if (
        dataFromResponse?.data === undefined ||
        dataFromResponse?.data === null
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as GetFilesByCustomerIdResponseModel,
        };
      }

      return {
        success: true,
        data: dataFromResponse.data,
        error: '',
      };
    }

    return {
      success: false,
      error: response.error ?? '',
      data: {} as GetFilesByCustomerIdResponseModel,
    };
  }

  async getGenericFees(
    queryFilters: GetGenericFeesData['query'],
  ): Promise<{ success: boolean; data: FeeResponseModel; error: string }> {
    this.options.headers['X-Organization-ID'];
    let response = await this.handleRequest(
      getGenericFees({
        ...this.options,
        query: queryFilters,
      }),
      'Error fetching generic fees',
    );
    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return { success: false, error: 'Api response error', data: {} };
      }
      return {
        success: true,
        data: dataFromResponse.data as FeeResponseModel,
        error: '',
      };
    } else {
      return { success: false, error: response.error ?? '', data: {} };
    }
  }

  async getCustomerSettings(customerId: string): Promise<{
    success: boolean;
    data: GetCustomerSettingsResponseModel;
    error: string;
  }> {
    this.options.headers['X-Organization-ID'] = environment.organization_id;
    this.options.headers['customer_id'] = customerId;
    let response = await this.handleRequest(
      getCustomerSettings({
        ...this.options,
      }),
      'Erros fetching customer settings',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return { success: false, error: 'Api response error', data: {} };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: {} };
    }
  }

  async patchCustomerSettings(
    customerId: string,
    body: PatchCustomerSettingsData['body'],
  ): Promise<{
    success: boolean;
    data: PatchCustomerSettingsResponseModel;
    error: string;
  }> {
    this.options.headers['customer_id'] = customerId;
    let response = await this.handleRequest(
      patchCustomerSettings({
        ...this.options,
        body: body,
      }),
      'Error in patching the Customer Settings',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return { success: false, error: 'Api response error', data: {} };
      }
      return {
        success: true,
        data: dataFromResponse.data as PatchCustomerSettingsResponseModel,
        error: '',
      };
    } else {
      return { success: false, error: response.error ?? '', data: {} };
    }
  }

  async uploadFile(
    customerId: string,
    body: UploadFileInputPayload,
    queryFilters: UploadFileData['query'],
  ): Promise<{
    success: boolean;
    data: UploadFileResponseModel;
    error: string;
  }> {
    this.options.headers['customer_id'] = customerId;
    // this.options.headers['Content-Type'] = 'application/json'

    let responseFromApi = await this.handleRequest(
      uploadFile({
        ...this.options,
        query: queryFilters,
        body: body,
      }),
      'Error in uploading file',
    );

    if (responseFromApi.success) {
      let dataFromResponse = responseFromApi.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return { success: false, error: 'Api response error', data: {} };
      }
      return {
        success: true,
        data: dataFromResponse.data as UploadFileResponseModel,
        error: '',
      };
    } else {
      return { success: false, error: responseFromApi.error ?? '', data: {} };
    }
  }

  async generateBankDetailsPdf(
    body: GenerateBankDetailsPdfData['body'],
  ): Promise<{ success: boolean; data: Blob; error: string }> {
    let response = await this.handleRequest(
      generateBankDetailsPdf({
        ...this.options,
        body: body,
      }),
      'Error in generating bank details pdf',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (dataFromResponse === undefined) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as Blob,
        };
      }
      return { success: true, data: dataFromResponse as Blob, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: {} as Blob };
    }
  }

  async generateHdfcIrmReport(
    customerId: string,
    body: GenerateHdfcIrmReportData['body'],
  ): Promise<{ success: boolean; data: Blob; error: string }> {
    this.options.headers.customer_id = customerId;
    let response = await this.handleRequest(
      generateHdfcIrmReport({
        ...this.options,
        body: body,
      }),
      'Error in generating HDFC IRM report',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (dataFromResponse === undefined) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as Blob,
        };
      }
      return { success: true, data: dataFromResponse as Blob, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: {} as Blob };
    }
  }

  async generateHdfcRequestLetter(
    customerId: string,
    body: GenerateHdfcRequestLetterData['body'],
  ): Promise<{ success: boolean; data: Blob; error: string }> {
    this.options.headers.customer_id = customerId;
    let response = await this.handleRequest(
      generateHdfcRequestLetter({
        ...this.options,
        body: body,
      }),
      'Error in generating HDFC Request Letter',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (dataFromResponse === undefined) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as Blob,
        };
      }
      return { success: true, data: dataFromResponse as Blob, error: '' };
    } else {
      return { success: false, error: response.error ?? '', data: {} as Blob };
    }
  }

  async postEmailUnsubscribe(
    hash: string,
    body: PostEmailUnsubscribeRequestContent,
  ): Promise<{
    success: boolean;
    data: UnsubscribeStatusModel;
    error: string;
  }> {
    let response = await this.handleRequest(
      postEmailUnsubscribe({
        path: { hash: hash },
        ...this.options,
        body: body,
      }),
      'Error in unsubscribing from email',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as UnsubscribeStatusModel,
        };
      }
      return {
        success: true,
        data: dataFromResponse.data as UnsubscribeStatusModel,
        error: '',
      };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as UnsubscribeStatusModel,
      };
    }
  }

  async getEmailUnsubscribeStatus(hash: string): Promise<{
    success: boolean;
    data: UnsubscribeStatusModel;
    error: string;
  }> {
    let response = await this.handleRequest(
      getEmailUnsubscribeStatus({
        path: { hash: hash },
        ...this.options,
      }),
      'Error in unsubscribing from email',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as UnsubscribeStatusModel,
        };
      }
      return {
        success: true,
        data: dataFromResponse.data as UnsubscribeStatusModel,
        error: '',
      };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as UnsubscribeStatusModel,
      };
    }
  }

  async postContactForm(body: PostContactFormData['body']): Promise<{
    success: boolean;
    data: ContactFormResponseModel;
    error: string;
  }> {
    let response = await this.handleRequest(
      postContactForm({
        ...this.options,
        body: body,
      }),
      'Error in submitting contact form',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as ContactFormResponseModel,
        };
      }
      return {
        success: true,
        data: dataFromResponse.data as ContactFormResponseModel,
        error: '',
      };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as ContactFormResponseModel,
      };
    }
  }

  async getNfcCardDetails(
    userId: string,
  ): Promise<{ success: boolean; data: NfcCardModel; error: string }> {
    let response = await this.handleRequest(
      getNfcCardDetails({
        headers: {
          ...this.options.headers,
        },
        path: {
          user_id: userId,
        },
      }),
      'Failed to get NFC card details',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as NfcCardModel,
        };
      }
      return {
        success: true,
        data: dataFromResponse.data as NfcCardModel,
        error: '',
      };
    }

    return {
      success: false,
      data: {} as NfcCardModel,
      error: response.error || 'Failed to get NFC card details',
    };
  }

  async createOrUpdateNfcCard(
    userId: string,
    body: CreateOrUpdateNfcCardRequestContent,
  ): Promise<{ success: boolean; data: NfcCardModel; error: string }> {
    let response = await this.handleRequest(
      createOrUpdateNfcCard({
        headers: {
          ...this.options.headers,
        },
        path: {
          user_id: userId,
        },
        body,
      }),
      'Failed to create/update NFC card',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as NfcCardModel,
        };
      }
      return {
        success: true,
        data: dataFromResponse.data as NfcCardModel,
        error: '',
      };
    }

    return {
      success: false,
      data: {} as NfcCardModel,
      error: response.error || 'Failed to create/update NFC card',
    };
  }

  private handleApiResponse<T>(
    response: { success: boolean; data?: any; error?: string },
    defaultData: T,
  ): {
    success: boolean;
    data: T;
    error: string;
  } {
    if (response.success) {
      const dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: defaultData,
        };
      }
      return {
        success: true,
        data: dataFromResponse.data as T,
        error: '',
      };
    }
    return {
      success: false,
      error: response.error ?? '',
      data: defaultData,
    };
  }

  async sendOtp(requestBody: SendOtpData['body']): Promise<{
    success: boolean;
    data: VerifyOtpResponseModel;
    error: string;
  }> {
    const response = await this.handleRequest(
      sendOtp({
        ...this.options,
        body: requestBody,
      }),
      'Error in sending OTP',
    );

    return this.handleApiResponse<VerifyOtpResponseModel>(
      response,
      {} as VerifyOtpResponseModel,
    );
  }

  async verifyOtp(requestData: VerifyOtpData['body']): Promise<{
    success: boolean;
    data: VerifyOtpResponseModel;
    error: string;
  }> {
    const response = await this.handleRequest(
      verifyOtp({
        ...this.options,
        body: requestData,
      }),
      'Error in verifying OTP',
    );

    return this.handleApiResponse<VerifyOtpResponseModel>(
      response,
      {} as VerifyOtpResponseModel,
    );
  }

  /*

 * Update User

  export const patchUser = <ThrowOnError extends boolean = false>(options: Options<PatchUserData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PatchUserResponse, unknown, ThrowOnError>({
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers
      },
      url: '/api/v1/users'
    });
  };
* */
  async patchUser(body: PatchUserData['body']): Promise<{
    success: boolean;
    data: UserModel;
    error: string;
  }> {
    let response = await this.handleRequest(
      patchUser({
        ...this.options,
        body: body,
      }),
      'Error in updating user',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as UserModel,
        };
      }
      return {
        success: true,
        data: dataFromResponse.data as UserModel,
        error: '',
      };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as UserModel,
      };
    }
  }

  async deleteFileById(path: DeleteFileByIdData['path']): Promise<{
    success: boolean;
    data: DeleteFileByIdResponseContent;
    error: string;
  }> {
    let response = await this.handleRequest(
      deleteFileById({
        ...this.options,
        path: path,
      }),
      'Error in deleting file id',
    );

    if (response.success) {
      let dataFromResponse = response.data;

      if (dataFromResponse === undefined) {
        return {
          success: false,
          error: 'Api response error',
          data: {
            message: '',
          },
        };
      }
      return {
        success: true,
        error: '',
        data: { message: 'File Id successfully deleted' },
      };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: { message: '' },
      };
    }
  }

  async getFIRABreakDown(firaFile: File): Promise<{
    success: boolean;
    data: GetCostsFromFircResponseModel;
    error: string;
  }> {
    let response = await this.handleRequest(
      getCostsFromFirc({
        ...this.options,
        body: firaFile,
        query: { file_name: firaFile.name },
      }),
      'Error in processing FIRA file',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as GetCostsFromFircResponseModel,
        };
      }
      return {
        success: true,
        data: dataFromResponse.data as GetCostsFromFircResponseModel,
        error: '',
      };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as GetCostsFromFircResponseModel,
      };
    }
  }

  async getFIRABreakDownById(id: string): Promise<{
    success: boolean;
    data: GetFircUploadResponseByIdModel;
    error: string;
  }> {
    let response = await this.handleRequest(
      getFircUploadResponseById({
        ...this.options,
        path: { id: id },
      }),
      'Error in fetching FIRA breakdown by ID',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as GetFircUploadResponseByIdModel,
        };
      }

      return {
        success: true,
        data: dataFromResponse.data as GetFircUploadResponseByIdModel,
        error: '',
      };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as GetFircUploadResponseByIdModel,
      };
    }
  }

  async getAffiliateVendors(): Promise<{
    success: boolean;
    data: AffiliateCustomersData;
    error: string;
  }> {
    let response = await this.handleRequest(
      getAffiliateCustomers({
        ...this.options,
      }),
      'Error in fetching affiliate vendors',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as AffiliateCustomersData,
        };
      }
      // Extract linkedCustomer array from AffiliateCustomersData
      const linkedCustomers = dataFromResponse.data.linked_customer || [];
      return {
        success: true,
        data: dataFromResponse.data,
        error: '',
      };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as AffiliateCustomersData,
      };
    }
  }

  async updatePayoutFeeConfig(
    affiliateVendorId: string,
    payoutFeeConfig: PayoutFeeConfig,
  ): Promise<{
    success: boolean;
    data: void;
    error: string;
  }> {
    // Transform PayoutFeeConfig to UpdateAffiliateCustomerFeeRequestContent
    const updateFeeRequest: UpdateAffiliateCustomerFeeRequestContent = {
      fee: {
        fixed_fee: payoutFeeConfig.fixedPayoutFees,
        variable_fee_percentage: payoutFeeConfig.variablePayoutFeesPercentage,
        minimum_amount: payoutFeeConfig.minimumPayoutAmount,
        fx_rate: payoutFeeConfig.fxRate,
        sell_currency: payoutFeeConfig.sourceCurrency,
        buy_currency: payoutFeeConfig.destinationCurrency,
      },
    };

    let response = await this.handleRequest(
      updateAffiliateCustomerFee({
        ...this.options,
        path: { cid: affiliateVendorId },
        body: updateFeeRequest,
      }),
      'Error in updating payout fee config',
    );

    return this.handleApiResponse<void>(response, undefined);
  }

  async getIdentityVerifications(): Promise<{
    success: boolean;
    data: GetIdentityVerificationsResponseModel;
    error: string;
  }> {
    const response = await this.handleRequest(
      getIdentityVerifications({
        ...this.options,
      }),
      'Error in fetching identity verifications',
    );

    if (response.success) {
      const dataFromResponse = response.data;
      if (!dataFromResponse?.data) {
        return {
          success: false,
          error: 'Api response error',
          data: { identity_verifications: [] },
        };
      }

      return {
        success: true,
        data: dataFromResponse.data,
        error: '',
      };
    }

    return {
      success: false,
      error: response.error ?? '',
      data: { identity_verifications: [] },
    };
  }

  async patchIdentityVerificationQueryDocuments(
    verificationId: string,
    body: PatchIdentityVerificationQueryDocumentsRequestContent & {
      linked_id?: string;
    },
  ): Promise<{
    success: boolean;
    data: PatchIdentityVerificationQueryDocumentsResponseModel;
    error: string;
  }> {
    this.options.headers['X-Organization-ID'] = environment.organization_id;

    const response = await this.handleRequest(
      patchIdentityVerificationQueryDocuments({
        ...this.options,
        path: { verification_id: verificationId },
        body,
      }),
      'Error submitting identity verification query document',
    );

    if (response.success) {
      const dataFromResponse = response.data?.data;
      if (!dataFromResponse) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as PatchIdentityVerificationQueryDocumentsResponseModel,
        };
      }

      return {
        success: true,
        data: dataFromResponse,
        error: '',
      };
    }

    return {
      success: false,
      error: response.error ?? '',
      data: {} as PatchIdentityVerificationQueryDocumentsResponseModel,
    };
  }

  async getAffiliateCommissions(): Promise<{
    success: boolean;
    data: AffiliateCommissionsData;
    error: string;
  }> {
    let response = await this.handleRequest(
      getAffiliateCommissions({
        ...this.options,
      }),
      'Error in fetching affiliate commissions',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: {} as AffiliateCommissionsData,
        };
      }
      const affiliateCommissions = dataFromResponse.data.commissions || [];
      return {
        success: true,
        data: dataFromResponse.data,
        error: '',
      };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: {} as AffiliateCommissionsData,
      };
    }
  }

  async getPurposeCodes(customerId: string): Promise<{
    success: boolean;
    data: PurposeCodeModel[];
    error: string;
  }> {
    let response = await this.handleRequest(
      getPurposeCodes({
        ...this.options,
        headers: {
          ...this.options.headers,
          customer_id: customerId,
        },
      }),
      'Error fetching purpose codes',
    );

    if (response.success) {
      let dataFromResponse = response.data;
      if (
        dataFromResponse === undefined ||
        dataFromResponse.data === undefined
      ) {
        return {
          success: false,
          error: 'Api response error',
          data: [],
        };
      }
      return { success: true, data: dataFromResponse.data, error: '' };
    } else {
      return {
        success: false,
        error: response.error ?? '',
        data: [],
      };
    }
  }

  async getUserByEmail(
    email: string,
  ): Promise<{ success: boolean; data: UserModel; error: string }> {
    const response = await this.handleRequest(
      getUserByEmail({
        ...this.options,
        query: { email },
      }),
      'Error fetching user by email',
    );

    if (response.success) {
      const dataFromResponse = response.data;
      if (!dataFromResponse?.data) {
        return {
          success: false,
          error: 'User not found',
          data: {} as UserModel,
        };
      }
      return {
        success: true,
        data: dataFromResponse.data as UserModel,
        error: '',
      };
    }

    return {
      success: false,
      error: response.error ?? '',
      data: {} as UserModel,
    };
  }

  async postAffiliateUser(
    body: PostAffiliateUserRequestContent,
  ): Promise<{ success: boolean; data: AffiliateUserData; error: string }> {
    const response = await this.handleRequest(
      postAffiliateUser({
        ...this.options,
        body,
      }),
      'Error marking user as affiliate partner',
    );

    return this.handleApiResponse<AffiliateUserData>(
      response,
      {} as AffiliateUserData,
    );
  }
}
